/**
 * useEffectでURLを監視する方法はやめる
 */
import { useAtomValue, useSetAtom } from 'jotai'
import * as R from 'ramda'
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import { useLocation } from 'react-router-dom'

import { routeParams } from '../@types/route'
import { filterState } from '../atoms/filterState'
import { settingsState } from '../atoms/settingsState'
import { getColorFromChar } from '../utils/color'
import { getRyoikisFromHash } from '../utils/hash'

type RyoikiType = {
  label: string
  checked: boolean
  data: string[]
  id: string
}

// 公開したいメソッドの定義
export type RyoikiFilterHandlers = {
  reset(): void
}

export const RyoikiFilter = forwardRef<RyoikiFilterHandlers>((_, ref) => {
  const updateFilter = useSetAtom(filterState)
  const { selector } = useAtomValue(settingsState)
  const { state }: { state: routeParams | null } = useLocation()

  const [ryoikis, setRyoikis] = useState<RyoikiType[]>(() => {
    return R.map(record => {
      return {
        label: record.label,
        checked: false,
        data: record.data,
        id: record.id,
      }
    }, selector)
  })

  // useImperativeHandle
  useImperativeHandle(ref, () => {
    const reset = () => {
      const ids = R.pluck('id', ryoikis)
      setIdsChecked(ids, false)
    }
    return {
      reset,
    }
  })

  /**
   * コンポーネントが開いたときの処理
   */
  useEffect(() => {
    if (state) {
      // プログラムで移動してきた
      setIdsChecked([state.connectedRyoikiIds], true)
    } else {
      // URLで移動してきた
      setIdsChecked(getRyoikisFromHash(), true)
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  /**
   * 指定したidを一気にcheckに更新する
   * @param ids
   * @param check
   */
  const setIdsChecked = (ids: string[], check: boolean) => {
    // console.log('', ids)
    setRyoikis(prevState =>
      prevState.map(item => {
        // console.log('item:', item)
        return {
          ...item,
          checked: ids.includes(item.id) ? check : item.checked,
        }
      })
    )
  }
  /**
   * チェックのON/OFFしたら、自分のステートを更新し、URLを更新する
   * @param e
   */
  const onChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { checked, id } = e.target

    const ids = R.pluck(
      'id',
      temporaryState(id, checked).filter(r => r.checked)
    )

    // 自身のGUIのチェックたちを更新する
    setIdsChecked([id], checked)

    // 全体のフィルタを更新する
    updateFilter(prev => {
      return {
        ...prev,
        ryoikiIds: ids,
      }
    })
  }

  const temporaryState = (label: string, checked: boolean) => {
    return ryoikis.map(value => {
      return value.id === label ? { ...value, checked } : value
    })
  }

  return (
    <div className="py-1">
      {ryoikis.map(s => {
        return (
          <span
            key={s.id}
            style={{ backgroundColor: getColorFromChar(s.id[2]) }}
            // className="inline-flex items-center gap-1.5 py-1.5 px-3 m-1 rounded-md text-xs font-medium bg-gray-100 text-blue-800"
            className="inline-flex items-center gap-1.5 py-1.5 px-3 m-1 rounded-md text-xs font-medium text-gray-800"
          >
            <input
              className="cursor-pointer"
              // id={s.label}
              id={s.id}
              type="checkbox"
              value={s.label}
              // value={s.id}
              onChange={onChangeInput}
              checked={s.checked}
            />
            <label className="cursor-pointer" htmlFor={s.id}>
              {s.label}
            </label>
          </span>
        )
      })}
    </div>
  )
})
